function isProduction () {
  return window.location.hostname.includes('app.likvi.de')
}

export { isProduction }
